import React, { createContext, useState, useContext, ReactNode } from "react";

// Define the form's data structure
export type StorageFormData = {
  productSpecificationName: string;
  specificationNumber: number;
  version: number;
  status: string;
  vendorName: string;
  specificationType: string;
  // Storage details
  primaryShelfLifeCodingFromDateOf: string;
  period: string;
  formatOfShelfLifeCoding: string;
  traderJoesDistributionChain: string;
  // Pack coding
  primaryShelfLife: string;
  primaryShelfLifeNumber: number;
  primaryShelfLifeOuterCase: boolean;
  secondaryShelfLife: string;
  secondaryShelfLifeNumber: number;
  secondaryShelfLifeOuterCase: boolean;
  comments: string;
  // Attachments
  section: string;
  filenameOrURL: string; //auto populated
  description: string;
  bytes: number; //auto populated
  attachedBy: string; //auto populated
  attachedOn: string; //auto populated
};

// Initial form data
const initialStorageFormData: StorageFormData = {
  productSpecificationName: "",
  specificationNumber: 0,
  version: 0,
  status: "",
  vendorName: "",
  specificationType: "",
  primaryShelfLifeCodingFromDateOf: "",
  period: "",
  formatOfShelfLifeCoding: "",
  traderJoesDistributionChain: "",
  primaryShelfLife: "",
  primaryShelfLifeNumber: 0,
  primaryShelfLifeOuterCase: false,
  secondaryShelfLife: "",
  secondaryShelfLifeNumber: 0,
  secondaryShelfLifeOuterCase: false,
  comments: "",
  section: "",
  filenameOrURL: "",
  description: "",
  bytes: 0,
  attachedBy: "",
  attachedOn: "",
};

interface StorageContextProps {
  storageForm: StorageFormData;
  setStorageForm: React.Dispatch<React.SetStateAction<StorageFormData>>;
}

const StorageContext = createContext<StorageContextProps | undefined>(undefined);

export const StorageProvider = ({ children }: { children: ReactNode }) => {
  const [storageForm, setStorageForm] = useState<StorageFormData>(initialStorageFormData);

  return (
    <StorageContext.Provider value={{ storageForm, setStorageForm }}>
      {children}
    </StorageContext.Provider>
  );
};

export const useStorageContext = () => {
  const context = useContext(StorageContext);
  if (context === undefined) {
    throw new Error("useStorageContext must be used within a StorageProvider");
  }
  return context;
};
